import React from 'react';
import { Link } from 'react-router-dom';

const companyLinks = [
  {
    name: "À propos",
    path: "/a-propos"
  },
  {
    name: "Nos projets",
    path: "/projets"
  },
  {
    name: "Collab",
    path: "/collab"
  },
  {
    name: "Blog",
    path: "/blog"
  },
  {
    name: "Contact",
    path: "/contact"
  }
];

const CompanyLinks = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">L'entreprise</h3>
      <ul className="space-y-2">
        {companyLinks.map((link) => (
          <li key={link.path}>
            <Link
              to={link.path}
              className="text-gray-600 hover:text-orcsys-500 transition-colors"
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CompanyLinks; 